import {createContext, useContext, useEffect, useState} from 'react';
import { jwtDecode } from 'jwt-decode';


const MyContext = createContext();

const MyProvider = ({children}) => {
    const [role, setRole] = useState('');
    const [data, setData] = useState(null);
    const [lang, setLang] = useState(() => sessionStorage.getItem('language') || 1);

    const getUserDataFromToken = (token) => {
        try {
          // Decode the JWT token
          const decodedToken = jwtDecode(token);
          
          // Extract the role and username from the decoded payload
          const role = decodedToken.role; 
          const username = decodedToken.username; 
      
          return { role, username };
        } catch (error) {
          console.error('Error decoding token:', error);
          return null;
        }
      };
      const token=localStorage.getItem("token");
    useEffect(() => {
      if(token){
        const userData = getUserDataFromToken(token);
        if(userData){
            setRole(userData.role);
        }
     }
    }, [role,token])

    useEffect(() => {
        sessionStorage.setItem('language', lang)
    }, [lang])

    return (
        <MyContext.Provider value={{role, setRole, lang, setLang,data, setData}}>
            {children}
        </MyContext.Provider>
    );
}

export default MyProvider

export const useMyContext = () => useContext(MyContext);
